const getBundleAtc = document.querySelectorAll('[data-bundle-atc]');
const getProductDetails = [];
const bundleRoot = document.querySelector('.custom-bundle');
const MAX_ITEMS = bundleRoot
  ? parseInt(bundleRoot.dataset.bundleQuantity || '4', 10)
  : 4;
const progressFills = document.querySelectorAll('[data-progress-fill]');
const selectedCountElement = document.querySelector('[data-selected]');
const cartPriceElement = document.querySelector('[data-cart-price]');
const progressPoints = document.querySelectorAll('.bundle-progress-point');
let productBoxes = document.querySelectorAll('[data-product-box]');
const selectedProductsSlider = document.querySelector('[data-selected-products-slider]');
const selectedProductsTrack = document.querySelector('[data-selected-products-track]');
const selectedProductsPrev = document.querySelector('[data-selected-products-prev]');
const selectedProductsNext = document.querySelector('[data-selected-products-next]');
const selectedProductsContainer = selectedProductsTrack;
const bundleTotalElement = document.querySelector('[data-bundle-total]');
const bundleSubmitButton = document.querySelector('[data-bundle-submit]');
const offerSubtitle = document.querySelector('[data-offer-subtitle]');
const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');
let isCartSyncing = false;
let previousSelectedProductCount = 0;
let currentCart = null;

const EMPTY_PRODUCT_BOX_HTML = `
  <div class="selected-product-box__empty">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3C8.27614 3 8.5 3.22386 8.5 3.5V8H13C13.2761 8 13.5 8.22386 13.5 8.5C13.5 8.77614 13.2761 9 13 9H8.5V13.5C8.5 13.7761 8.27614 14 8 14C7.72386 14 7.5 13.7761 7.5 13.5V9H3C2.72386 9 2.5 8.77614 2.5 8.5C2.5 8.22386 2.72386 8 3 8H7.5V3.5C7.5 3.22386 7.72386 3 8 3Z" fill="#9CA3AF"/>
    </svg>
  </div>
`;

const BUNDLE_PRICE_CENTS = bundleRoot
  ? parseInt(bundleRoot.dataset.bundleTotalPrice || '9999', 10)
  : 9999;

  const bundleOverlay = document.createElement('div');
  bundleOverlay.id = 'bundle-loading-overlay';
  bundleOverlay.innerHTML = `<div class="bundle-loading-spinner"></div>`;
  Object.assign(bundleOverlay.style, {
    display: 'none',
    position: 'fixed',
    inset: '0',
    zIndex: '99999',
    background: 'rgba(255, 255, 255, 0.65)',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(2px)',
  });
  document.body.appendChild(bundleOverlay);
  
  function showBundleLoading() { bundleOverlay.style.display = 'flex'; }
  function hideBundleLoading() { bundleOverlay.style.display = 'none'; }  
// Function to get current currency rate and convert bundle price
function getConvertedBundlePrice() {
  let rate = 1;

  if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
    rate = parseFloat(Shopify.currency.rate);
  }

  return (BUNDLE_PRICE_CENTS / 100) * rate;
}

// Per-product tier prices (USD), converted by store currency rate
const TIER_2_PRICE = 41.22;
const TIER_3_PRICE = 33.33;

function getCurrencyRate() {
  if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) {
    return parseFloat(Shopify.currency.rate);
  }
  return 1;
}

function getOriginalProductsTotal() {
  let total = 0;
  getProductDetails.forEach(function (product) {
    total += parsePriceValue(product.comparePrice || product.price);
  });
  return total;
}

// Tier display for 1–3 items; 4+ uses cart totals via getBundleCartTotals
function getTieredDisplayTotal() {
  const selectedCount = getProductDetails.length;
  if (selectedCount === 0) return 0;

  const rate = getCurrencyRate();

  if (selectedCount === 1) {
    const first = getProductDetails[0];
    return parsePriceValue(first.comparePrice || first.price);
  }

  if (selectedCount === 2) {
    return 2 * (TIER_2_PRICE * rate);
  }

  if (selectedCount === 3) {
    return 3 * (TIER_3_PRICE * rate);
  }

  return 0;
}

// Helper function to extract currency info from a price string
function extractCurrencyInfo(priceString) {
  if (!priceString) return { symbol: '$', position: 'before' };
  
  const str = priceString.toString().trim();
  
  // Match currency symbol at the beginning
  const beforeMatch = str.match(/^([^\d\s.,]+)\s*/);
  if (beforeMatch) {
    return { symbol: beforeMatch[1], position: 'before' };
  }
  
  // Match currency symbol at the end
  const afterMatch = str.match(/\s*([^\d\s.,]+)$/);
  if (afterMatch) {
    return { symbol: afterMatch[1], position: 'after' };
  }
  
  // Default to dollar sign before
  return { symbol: '$', position: 'before' };
}

// Helper function to parse price string to number
function parsePriceValue(priceString) {
  if (!priceString) return 0;
  
  const str = priceString.toString().trim();
  
  // Extract the first numeric-looking portion so currency symbols that contain dots (e.g. "Dhs.") don't interfere
  const numericMatch = str.match(/-?\d[\d.,]*/);
  let cleanStr = numericMatch ? numericMatch[0] : str.replace(/[^\d.,-]/g, '');
  
  // Remove any leading separators that might remain (e.g. ",205")
  cleanStr = cleanStr.replace(/^[.,]+/, '');
  
  // Determine decimal separator: last separator with 1-2 digits to the right
  const lastDotIndex = cleanStr.lastIndexOf('.');
  const lastCommaIndex = cleanStr.lastIndexOf(',');
  let decimalSeparator = null;
  let decimalIndex = -1;
  
  if (lastDotIndex > lastCommaIndex) {
    const digitsAfter = cleanStr.length - lastDotIndex - 1;
    if (digitsAfter > 0 && digitsAfter <= 2) {
      decimalSeparator = '.';
      decimalIndex = lastDotIndex;
    }
  } else if (lastCommaIndex > -1) {
    const digitsAfter = cleanStr.length - lastCommaIndex - 1;
    if (digitsAfter > 0 && digitsAfter <= 2) {
      decimalSeparator = ',';
      decimalIndex = lastCommaIndex;
    }
  }
  
  let normalized = cleanStr.replace(/[.,]/g, '');
  
  if (decimalSeparator && decimalIndex !== -1) {
    const integerPart = cleanStr.slice(0, decimalIndex).replace(/[^\d-]/g, '');
    const decimalPart = cleanStr.slice(decimalIndex + 1).replace(/[^\d]/g, '');
    normalized = `${integerPart}.${decimalPart}`;
  }
  
  const value = parseFloat(normalized);
  return isNaN(value) ? 0 : value;
}

// Helper function to format price with currency
function formatPrice(amount, currencyInfo) {
  // Format number with 2 decimals
  const formattedAmount = amount.toFixed(2);
  
  // Use comma as decimal separator for currencies that typically use it
  const useComma = currencyInfo.position === 'after' || 
                   currencyInfo.symbol === '€' || 
                   currencyInfo.symbol === 'kr' ||
                   currencyInfo.symbol === 'zł' ||
                   currencyInfo.symbol === 'Kč';
  
  const displayAmount = useComma ? formattedAmount.replace('.', ',') : formattedAmount;
  
  if (currencyInfo.position === 'after') {
    return displayAmount + ' ' + currencyInfo.symbol;
  }
  return currencyInfo.symbol + displayAmount;
}

function getBundleVariantIds() {
  const ids = new Set();
  getBundleAtc.forEach(function (btn) {
    if (btn.dataset.bundleId) {
      ids.add(String(btn.dataset.bundleId));
    }
  });
  return ids;
}

function getBundleCartTotals(cart) {
  if (!cart || !cart.items) {
    return { totalCents: 0, originalTotalCents: 0 };
  }

  const bundleVariantIds = getBundleVariantIds();
  let totalCents = 0;
  let originalTotalCents = 0;

  cart.items.forEach(function (line) {
    if (!bundleVariantIds.has(String(line.variant_id))) {
      return;
    }

    const lineTotal =
      line.final_line_price != null ? line.final_line_price : line.line_price;
    const lineOriginal =
      line.original_line_price != null ? line.original_line_price : lineTotal;

    totalCents += lineTotal;
    originalTotalCents += lineOriginal;
  });

  return { totalCents, originalTotalCents };
}

function formatMoneyFromCents(cents) {
  if (typeof theme !== 'undefined' && theme.utils && theme.utils.formatMoney) {
    const moneyFormat =
      theme.settings && theme.settings.moneyFormat
        ? theme.settings.moneyFormat
        : typeof window !== 'undefined' &&
            window.themeVariables &&
            window.themeVariables.settings &&
            window.themeVariables.settings.moneyFormat
          ? window.themeVariables.settings.moneyFormat
          : undefined;
    return theme.utils.formatMoney(cents, moneyFormat);
  }

  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }

  const currencyInfo =
    getProductDetails.length > 0
      ? extractCurrencyInfo(getProductDetails[0].price)
      : { symbol: '$', position: 'before' };
  return formatPrice(cents / 100, currencyInfo);
}

function getProductMetaFromDom(variantId) {
  const wrapper = document.querySelector(
    `[data-quantity-wrapper][data-product-id="${variantId}"]`
  );
  const atcBtn = getAtcButtonByProductId(variantId);
  const source = wrapper || atcBtn;
  return source ? buildProductDataFromDataset(source.dataset) : null;
}

function getSectionsToBundle() {
  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    })
  );
  return sectionsToBundle;
}

function fetchCart() {
  const cartUrl =
    typeof theme !== 'undefined' && theme.routes && theme.routes.cart_url
      ? theme.routes.cart_url
      : '/cart.js';
  const config =
    typeof theme !== 'undefined' && theme.utils && theme.utils.fetchConfig
      ? theme.utils.fetchConfig()
      : {};
  return fetch(cartUrl, config).then(function (response) {
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }
    return response.json();
  });
}

function publishCartUpdate(cart, sections) {
  if (typeof theme === 'undefined' || !theme.pubsub) {
    return;
  }
  const cartJson = Object.assign({}, cart);
  if (sections) {
    cartJson.sections = sections;
  }
  theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
    source: 'custom-bundle',
    cart: cartJson
  });
}

// Change an existing cart line by key. /cart/change.js returns the FULL updated cart
// (with server-side bundle discounts already applied) in a single request, so neither
// the caller nor this helper needs a follow-up GET /cart.js.
async function changeCartLine(lineKey, quantity, sectionsToBundle) {
  const cartChangeUrl =
    typeof theme !== 'undefined' && theme.routes && theme.routes.cart_change_url
      ? theme.routes.cart_change_url
      : '/cart/change.js';
  const sections = sectionsToBundle || getSectionsToBundle();
  const config =
    typeof theme !== 'undefined' && theme.utils && theme.utils.fetchConfig
      ? theme.utils.fetchConfig()
      : { headers: { 'Content-Type': 'application/json' } };

  const response = await fetch(cartChangeUrl, {
    ...config,
    method: 'POST',
    body: JSON.stringify({
      id: lineKey,
      quantity: quantity,
      sections: sections,
      sections_url: window.location.pathname
    })
  });

  const parsedState = await response.json();
  if (!response.ok || parsedState.status) {
    throw new Error(parsedState.description || 'Failed to update cart');
  }

  // change.js already returns the full cart; only fall back to a fetch if it somehow didn't.
  const updatedCart = Array.isArray(parsedState.items) ? parsedState : await fetchCart();
  publishCartUpdate(updatedCart, parsedState.sections);
  return updatedCart;
}

async function addVariantToCart(variantId) {
  const sectionsToBundle = getSectionsToBundle();

  // Fast path: if this variant is already a line in the cart, increment it via
  // change.js (1 request, returns the full discounted cart) instead of
  // POST /cart/add.js + a separate GET /cart.js (2 requests).
  const existingLine =
    currentCart && currentCart.items
      ? currentCart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        })
      : null;

  if (existingLine) {
    return changeCartLine(existingLine.key, existingLine.quantity + 1, sectionsToBundle);
  }

  // New line: must use /cart/add.js. add.js returns only the added item, and adding a
  // new line can shift server-side bundle discounts across every line, so fetch the
  // authoritative cart for correct totals.
  const cartAddUrl =
    typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url
      ? theme.routes.cart_add_url
      : '/cart/add.js';
  const config =
    typeof theme !== 'undefined' && theme.utils && theme.utils.fetchConfig
      ? theme.utils.fetchConfig('javascript')
      : { headers: { 'Content-Type': 'application/json' } };

  const response = await fetch(cartAddUrl, {
    ...config,
    method: 'POST',
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: sectionsToBundle,
      sections_url: window.location.pathname
    })
  });

  const parsedState = await response.json();
  if (!response.ok || parsedState.status) {
    throw new Error(parsedState.description || 'Failed to add item to cart');
  }

  const cart = await fetchCart();
  publishCartUpdate(cart, parsedState.sections);
  return cart;
}

async function removeOneVariantFromCart(variantId) {
  // Find the line from the in-memory cart (kept fresh by syncFromCart) instead of an
  // extra GET /cart.js. Fall back to a fetch only if we don't have a cart yet.
  const sourceCart =
    currentCart && currentCart.items ? currentCart : await fetchCart();
  const line = sourceCart.items.find(function (item) {
    return String(item.variant_id) === String(variantId);
  });

  if (!line) {
    return sourceCart;
  }

  // Single request: change.js returns the full updated cart (see changeCartLine).
  return changeCartLine(line.key, line.quantity - 1, getSectionsToBundle());
}

function refreshProductBoxesQuery() {
  productBoxes = document.querySelectorAll('[data-product-box]');
}

function getRequiredBoxCount() {
  const selectedCount = getProductDetails.length;

  if (selectedCount > 3) {
    return Math.max(selectedCount, MAX_ITEMS);
  }

  if (selectedCount === 0) {
    return Math.min(MAX_ITEMS, 3);
  }

  const showEmptySlot = selectedCount < MAX_ITEMS && selectedCount < 3;
  return Math.min(showEmptySlot ? selectedCount + 1 : selectedCount, 3);
}

function getSelectedProductsSliderItemCount() {
  if (!selectedProductsTrack) {
    return 0;
  }

  return selectedProductsTrack.querySelectorAll('.selected-product-box.filled').length;
}

function updateSelectedProductsSliderClass() {
  if (!selectedProductsSlider) {
    return false;
  }

  const itemCount = getSelectedProductsSliderItemCount();
  const shouldScroll = itemCount > 3;

  if (shouldScroll) {
    selectedProductsSlider.classList.add('is-scrollable');
  } else {
    selectedProductsSlider.classList.remove('is-scrollable');
  }

  selectedProductsSlider.style.setProperty(
    '--slider-item-count',
    String(Math.max(productBoxes.length, 1))
  );

  return shouldScroll;
}

function updateSelectedProductsSliderState() {
  if (!selectedProductsTrack || !selectedProductsSlider) {
    return;
  }

  const isScrollable = updateSelectedProductsSliderClass();

  if (!isScrollable) {
    selectedProductsTrack.scrollLeft = 0;
    if (selectedProductsPrev) {
      selectedProductsPrev.hidden = true;
    }
    if (selectedProductsNext) {
      selectedProductsNext.hidden = true;
    }
    return;
  }

  const scrollLeft = selectedProductsTrack.scrollLeft;
  const maxScroll = selectedProductsTrack.scrollWidth - selectedProductsTrack.clientWidth;

  if (selectedProductsPrev) {
    selectedProductsPrev.hidden = false;
    selectedProductsPrev.disabled = scrollLeft <= 1;
  }
  if (selectedProductsNext) {
    selectedProductsNext.hidden = false;
    selectedProductsNext.disabled = scrollLeft >= maxScroll - 1;
  }
}

function scrollSelectedProducts(direction) {
  if (!selectedProductsTrack || !selectedProductsSlider.classList.contains('is-scrollable')) {
    return;
  }

  const boxes = Array.from(productBoxes);
  if (!boxes.length) {
    return;
  }

  const currentScroll = selectedProductsTrack.scrollLeft;
  let targetBox = null;

  if (direction === 'next') {
    targetBox = boxes.find(function (box) {
      return box.offsetLeft > currentScroll + 5;
    });
  } else {
    const previousBoxes = boxes.filter(function (box) {
      return box.offsetLeft < currentScroll - 5;
    });
    targetBox = previousBoxes[previousBoxes.length - 1];
  }

  if (targetBox) {
    selectedProductsTrack.scrollTo({
      left: targetBox.offsetLeft,
      behavior: 'smooth'
    });
  }
}

function scrollSelectedProductsToEnd() {
  if (!selectedProductsTrack || !selectedProductsSlider.classList.contains('is-scrollable')) {
    return;
  }

  selectedProductsTrack.scrollTo({
    left: selectedProductsTrack.scrollWidth,
    behavior: 'smooth'
  });
}

function initSelectedProductsSlider() {
  if (!selectedProductsTrack) {
    return;
  }

  selectedProductsTrack.addEventListener('scroll', updateSelectedProductsSliderState, { passive: true });
  window.addEventListener('resize', updateSelectedProductsSliderState);

  if (selectedProductsPrev) {
    selectedProductsPrev.addEventListener('click', function () {
      scrollSelectedProducts('prev');
    });
  }

  if (selectedProductsNext) {
    selectedProductsNext.addEventListener('click', function () {
      scrollSelectedProducts('next');
    });
  }

  updateSelectedProductsSliderState();
}

function ensureProductBoxes() {
  if (!selectedProductsContainer) {
    return;
  }

  const requiredCount = getRequiredBoxCount();
  let boxes = selectedProductsContainer.querySelectorAll('[data-product-box]');
  while (boxes.length > requiredCount) {
    boxes[boxes.length - 1].remove();
    boxes = selectedProductsContainer.querySelectorAll('[data-product-box]');
  }

  let currentCount = boxes.length;
  while (currentCount < requiredCount) {
    const box = document.createElement('div');
    box.className = 'selected-product-box empty';
    box.setAttribute('data-product-box', String(currentCount));
    box.innerHTML = EMPTY_PRODUCT_BOX_HTML;
    selectedProductsContainer.appendChild(box);
    currentCount += 1;
  }

  refreshProductBoxesQuery();
  updateSelectedProductsSliderState();
}

function updateAllProductQuantitySelectors() {
  getBundleVariantIds().forEach(function (variantId) {
    const qty = getProductQuantity(variantId);
    if (qty > 0) {
      showQuantitySelector(variantId);
      updateQuantityDisplayForProduct(variantId);
      const bundleButton = getAtcButtonByProductId(variantId);
      if (bundleButton) {
        bundleButton.classList.add('custom-bundle-hidden');
      }
    } else {
      hideQuantitySelector(variantId);
      const bundleButton = getAtcButtonByProductId(variantId);
      if (bundleButton) {
        bundleButton.classList.remove('custom-bundle-hidden');
        bundleButton.disabled = false;
        bundleButton.style.cursor = 'pointer';
        bundleButton.style.backgroundColor = '#000000';
        bundleButton.style.color = '#ffffff';
        bundleButton.style.border = 'unset';
      }
    }
  });
}

function syncFromCart(cart) {
  currentCart = cart;
  getProductDetails.length = 0;
  const bundleVariantIds = getBundleVariantIds();

  cart.items.forEach(function (line) {
    if (!bundleVariantIds.has(String(line.variant_id))) {
      return;
    }

    const meta = getProductMetaFromDom(line.variant_id);
    if (!meta) {
      return;
    }

    for (let i = 0; i < line.quantity; i += 1) {
      getProductDetails.push({
        id: meta.id,
        image: meta.image,
        title: meta.title,
        price: meta.price,
        comparePrice: meta.comparePrice,
        arrayIndex: getProductDetails.length
      });
    }
  });

  ensureProductBoxes();
  rebuildProductBoxes();
  updateAllProductQuantitySelectors();
  updateProgressBar();
  updateProgressPoints();
  updateSelectionDisplay();

  const openModal = document.querySelector('[data-bundle-modal]');
  const openModalProductId = openModal
    ? openModal.getAttribute('data-modal-product-id')
    : null;
  if (openModalProductId) {
    updateBundleModalFooter(openModalProductId);
  }
}

async function initBundleFromCart() {
  try {
    const cart = await fetchCart();
    syncFromCart(cart);
  } catch (error) {
    console.error('Failed to initialize bundle from cart:', error);
  }
}

// Function to update progress bar (desktop + mobile, synced to cart bundle items)
function updateProgressBar() {
  const selectedCount = getProductDetails.length;
  const progressPercentage = Math.min(100, (selectedCount / MAX_ITEMS) * 100);

  progressFills.forEach(function (fill) {
    fill.style.width = progressPercentage + '%';
  });
}

// Function to update selection count and total price
function updateSelectionDisplay() {
  const selectedCount = getProductDetails.length;
  const currencyInfo =
    getProductDetails.length > 0
      ? extractCurrencyInfo(getProductDetails[0].price)
      : { symbol: '$', position: 'before' };
  const useCartTotal = selectedCount > 3;
  const cartTotals = getBundleCartTotals(currentCart);

  // Update selected count
  if (selectedCountElement) {
    selectedCountElement.textContent = selectedCount;
  }

  if (cartPriceElement) {
    if (useCartTotal) {
      cartPriceElement.textContent = formatMoneyFromCents(cartTotals.totalCents);
    } else if (selectedCount > 0) {
      cartPriceElement.textContent = formatPrice(getTieredDisplayTotal(), currencyInfo);
    } else {
      cartPriceElement.textContent = formatPrice(0, currencyInfo);
    }
  }

  if (bundleTotalElement) {
    if (selectedCount === 0) {
      bundleTotalElement.textContent = formatPrice(0, currencyInfo);
      bundleTotalElement.removeAttribute('data-bundle-original-total');
      bundleTotalElement.removeAttribute('data-bundle-price');
      bundleTotalElement.removeAttribute('data-bundle-discount');
    } else if (useCartTotal) {
      const totalCents = cartTotals.totalCents;
      const originalTotalCents = cartTotals.originalTotalCents;
      const discountCents = originalTotalCents - totalCents;

      bundleTotalElement.setAttribute(
        'data-bundle-original-total',
        (originalTotalCents / 100).toFixed(2)
      );
      bundleTotalElement.setAttribute('data-bundle-price', (totalCents / 100).toFixed(2));
      bundleTotalElement.setAttribute('data-bundle-discount', (discountCents / 100).toFixed(2));

      if (discountCents > 0) {
        bundleTotalElement.innerHTML = `
          <span class="bundle-total__result">${formatMoneyFromCents(totalCents)}</span>
          <span class="bundle-total__original">${formatMoneyFromCents(originalTotalCents)}</span>
        `;
      } else {
        bundleTotalElement.textContent = formatMoneyFromCents(totalCents);
      }
    } else {
      const displayTotal = getTieredDisplayTotal();
      const originalTotal = getOriginalProductsTotal();
      const discount = originalTotal - displayTotal;

      bundleTotalElement.setAttribute('data-bundle-original-total', originalTotal.toFixed(2));
      bundleTotalElement.setAttribute('data-bundle-price', displayTotal.toFixed(2));
      bundleTotalElement.setAttribute('data-bundle-discount', discount.toFixed(2));

      if (discount > 0) {
        bundleTotalElement.innerHTML = `
          <span class="bundle-total__result">${formatPrice(displayTotal, currencyInfo)}</span>
          <span class="bundle-total__original">${formatPrice(originalTotal, currencyInfo)}</span>
        `;
      } else {
        bundleTotalElement.textContent = formatPrice(displayTotal, currencyInfo);
        bundleTotalElement.removeAttribute('data-bundle-original-total');
        bundleTotalElement.removeAttribute('data-bundle-price');
        bundleTotalElement.removeAttribute('data-bundle-discount');
      }
    }
  }
  
  // Update offer subtitle text
  updateOfferSubtitle();
  
  // Enable/disable submit button based on selection count
  updateSubmitButton();
  updateProductButtonsState();
  updateBundlePriceLabels();
}

// Function to update progress points with active class (uses data-step so both desktop + mobile bars stay in sync)
function updateProgressPoints() {
  const selectedCount = getProductDetails.length;
  const activeSteps = Math.min(selectedCount, MAX_ITEMS);

  progressPoints.forEach(function (point) {
    const step = parseInt(point.getAttribute('data-step'), 10) || 0;
    if (step <= activeSteps) {
      point.classList.add('active');
    } else {
      point.classList.remove('active');
    }
  });
}

// Function to update offer subtitle text based on selected count
// function updateOfferSubtitle() {
//   if (!offerSubtitle) return;
  
//   const selectedCount = getProductDetails.length;
  
//   const messages = {
//     0: "Add 4 hats to unlock bundle price",
//     1: "Add 3 more hats to unlock bundle price",
//     2: "Add 2 more hats to unlock bundle price",
//     3: "Add 1 more hat to unlock bundle price",
//     4: "Great choice! Your 4-hat bundle is ready"
//   };
  
//   offerSubtitle.textContent = messages[selectedCount] || messages[0];
// }
function updateOfferSubtitle() {
  if (!offerSubtitle) return;

  const selectedCount = getProductDetails.length;
  const remaining = MAX_ITEMS - selectedCount;

  if (selectedCount === 0) {
    offerSubtitle.textContent = `Add ${MAX_ITEMS} hats to unlock bundle price`;
  } else if (remaining > 0) {
    const hatWord = remaining === 1 ? 'hat' : 'hats';
    offerSubtitle.textContent = `Add ${remaining} more ${hatWord} to unlock bundle price`;
  } else {
    offerSubtitle.textContent = `Great choice! Your ${MAX_ITEMS}-hat bundle is ready`;
  }
}


// Function to enable/disable submit button and show/hide offer box
// function updateSubmitButton() {
//   const selectedCount = getProductDetails.length;
//   const remaining = MAX_ITEMS - selectedCount;
  
//   if (bundleSubmitButton) {
//     if (selectedCount === MAX_ITEMS) {
//       bundleSubmitButton.disabled = false;
//       bundleSubmitButton.classList.add('enabled');
//       bundleSubmitButton.textContent = 'Checkout';
//     } else {
//       bundleSubmitButton.disabled = true;
//       bundleSubmitButton.classList.remove('enabled');
      
//       // Update button text based on remaining products
//       if (selectedCount === 0) {
//         bundleSubmitButton.textContent = 'Start Bundling';
//       } else if (remaining === 1) {
//         bundleSubmitButton.textContent = 'Add 1 more';
//       } else {
//         bundleSubmitButton.textContent = `Add ${remaining} more`;
//       }
//     }
//   }
//   // Show/hide offer box based on selection
//   // if (offerBox) {
//   //   if (selectedCount === MAX_ITEMS) {
//   //     offerBox.style.display = 'flex';
//   //   } else {
//   //     offerBox.style.display = 'none';
//   //   }
//   // }
// }
function updateSubmitButton() {
  const selectedCount = getProductDetails.length;

  if (bundleSubmitButton) {
    if (selectedCount >= 1) {
      bundleSubmitButton.disabled = false;
      bundleSubmitButton.classList.add('enabled');
      bundleSubmitButton.textContent = 'Checkout';
    } else {
      bundleSubmitButton.disabled = true;
      bundleSubmitButton.classList.remove('enabled');
      bundleSubmitButton.textContent = 'Start bundling';
    }
  }

  // View Bundle on mobile: only show when at least 1 product added
  const atcButtonsWrapper = document.querySelector('.custom-bundle__wrapper-atc-buttons');
  if (atcButtonsWrapper) {
    if (selectedCount >= 1) {
      atcButtonsWrapper.classList.add('has-bundle-items');
    } else {
      atcButtonsWrapper.classList.remove('has-bundle-items');
    }
  }

  // Mobile-only: reveal / size the bottom bundle bar from scroll + selection
  updateMobileBundleVisibility();
  updateMobileCollapsedState();
}

// Keep mobile bundle panel collapsed when no products are selected
function updateMobileCollapsedState() {
  const wrapperLeft = document.querySelector('.custom-bundle__wrapper-left');
  const toggle = document.querySelector('.custom-bundle__wrapper-left-toggle');
  if (!wrapperLeft || window.innerWidth > 768) {
    return;
  }

  if (getProductDetails.length === 0) {
    wrapperLeft.classList.add('collapsed');
    if (toggle) {
      toggle.classList.remove('rotated');
    }
  }
}

// Mobile-only: after scrolling past .custom-bundle__mobile-progress, show the fixed
// .custom-bundle__wrapper-left. With an empty bundle, only the progress track inside
// .custom-bundle__progress-box is shown; after at least one product is added, the
// full box (tier copy, inner, CTAs) appears. Desktop: always visible, mobile classes cleared.
function updateMobileBundleVisibility() {
  const wrapperLeft = document.querySelector('.custom-bundle__wrapper-left');
  if (!wrapperLeft) return;

  const isMobileViewport = window.innerWidth <= 768;
  if (!isMobileViewport) {
    wrapperLeft.classList.remove('is-mobile-visible');
    wrapperLeft.classList.remove('custom-bundle__wrapper-left--mobile-bar-only');
    return;
  }

  const hasItems = getProductDetails.length > 0;
  const mobileProgress = document.querySelector('.custom-bundle__mobile-progress');
  let pastTopProgress = true;
  if (mobileProgress) {
    const headerHeight =
      parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      ) || 0;
    const rect = mobileProgress.getBoundingClientRect();
    pastTopProgress = rect.bottom <= headerHeight;
  }

  if (pastTopProgress) {
    wrapperLeft.classList.add('is-mobile-visible');
    if (!hasItems) {
      wrapperLeft.classList.add('custom-bundle__wrapper-left--mobile-bar-only');
    } else {
      wrapperLeft.classList.remove('custom-bundle__wrapper-left--mobile-bar-only');
    }
  } else {
    wrapperLeft.classList.remove('is-mobile-visible');
    wrapperLeft.classList.remove('custom-bundle__wrapper-left--mobile-bar-only');
  }
}

window.addEventListener('scroll', updateMobileBundleVisibility, { passive: true });
window.addEventListener('resize', updateMobileBundleVisibility);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateMobileBundleVisibility);
} else {
  updateMobileBundleVisibility();
}

// Set initial button state on load (overrides any cached HTML like "Add 3 hats")
if (bundleSubmitButton) {
  updateSubmitButton();
}

function buildProductDataFromDataset(dataset) {
  return {
    id: dataset.bundleId || dataset.productId,
    image: dataset.variantImage,
    title: dataset.variantTitle,
    price: dataset.variantPrice,
    comparePrice: dataset.variantComparePrice || null
  };
}

function getAtcButtonByProductId(productId) {
  return document.querySelector(`[data-bundle-atc][data-bundle-id="${productId}"]`);
}

function getCartQuantityForVariant(variantId) {
  if (!currentCart || !currentCart.items) {
    return getProductQuantity(variantId);
  }

  let qty = 0;
  currentCart.items.forEach(function (line) {
    if (String(line.variant_id) === String(variantId)) {
      qty += line.quantity;
    }
  });
  return qty;
}

function canAddMoreVariant(dataset) {
  if (!dataset) {
    return false;
  }

  if (dataset.variantAvailable === 'false') {
    return false;
  }

  if (dataset.inventoryManaged !== 'true') {
    return true;
  }

  if (dataset.inventoryPolicy === 'continue') {
    return true;
  }

  const inventory = parseInt(dataset.variantInventory, 10);
  if (isNaN(inventory)) {
    return true;
  }

  const variantId = dataset.bundleId || dataset.productId;
  return getCartQuantityForVariant(variantId) < inventory;
}

function isVariantSoldOut(dataset) {
  if (!dataset || dataset.variantAvailable === 'false') {
    return true;
  }

  if (dataset.inventoryManaged !== 'true' || dataset.inventoryPolicy === 'continue') {
    return false;
  }

  const inventory = parseInt(dataset.variantInventory, 10);
  return !isNaN(inventory) && inventory <= 0;
}

function setAtcButtonSoldOutState(btn, isSoldOut) {
  const label = btn.querySelector('span');
  if (!label) {
    return;
  }

  if (!btn.dataset.originalLabel) {
    btn.dataset.originalLabel = label.textContent;
  }

  label.textContent = isSoldOut ? 'Sold out' : btn.dataset.originalLabel;
}

function applyAtcButtonVisualState(btn, disabled, isSoldOut) {
  btn.disabled = disabled;
  btn.style.cursor = disabled ? 'not-allowed' : 'pointer';

  if (isCartSyncing) {
    btn.style.backgroundColor = '#F3F4F6';
    btn.style.color = '#000000';
    btn.style.border = '1px solid #D1D5DB';
    return;
  }

  if (disabled && isSoldOut) {
    btn.style.backgroundColor = '#F3F4F6';
    btn.style.color = '#9CA3AF';
    btn.style.border = '1px solid #D1D5DB';
    setAtcButtonSoldOutState(btn, true);
    return;
  }

  btn.style.backgroundColor = '#000000';
  btn.style.color = '#ffffff';
  btn.style.border = 'unset';
  setAtcButtonSoldOutState(btn, false);
}

function getProductQuantity(productId) {
  return getProductDetails.filter(product => product.id === productId).length;
}

function updateQuantityDisplayForProduct(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (!wrapper) return;
  const quantityValue = wrapper.querySelector('[data-quantity-value]');
  if (quantityValue) {
    quantityValue.textContent = getProductQuantity(productId);
  }
}

function showQuantitySelector(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (wrapper) {
    wrapper.classList.remove('custom-bundle-hidden');
  }
}

function hideQuantitySelector(productId) {
  const wrapper = document.querySelector(`[data-quantity-wrapper][data-product-id="${productId}"]`);
  if (wrapper) {
    wrapper.classList.add('custom-bundle-hidden');
    const quantityValue = wrapper.querySelector('[data-quantity-value]');
    if (quantityValue) {
      quantityValue.textContent = '1';
    }
  }
}

function updateProductButtonsState() {
  getBundleAtc.forEach(function (btn) {
    if (btn.classList.contains('custom-bundle-hidden')) {
      return;
    }

    const canAdd = canAddMoreVariant(btn.dataset);
    const isSoldOut = isVariantSoldOut(btn.dataset);
    applyAtcButtonVisualState(btn, isCartSyncing || !canAdd, isSoldOut);
  });

  quantityWrappers.forEach(function (wrapper) {
    const canAdd = canAddMoreVariant(wrapper.dataset);
    const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
    const decreaseBtn = wrapper.querySelector('[data-quantity-decrease]');
    if (increaseBtn) {
      increaseBtn.disabled = isCartSyncing || !canAdd;
    }
    if (decreaseBtn) {
      decreaseBtn.disabled = isCartSyncing;
    }
  });
}

// to show last product as free
// function updateBundlePriceLabels() {
//   const isBundleComplete = getProductDetails.length === MAX_ITEMS;

//   productBoxes.forEach((box, index) => {
//     if (!box.classList.contains('filled')) {
//       return;
//     }

//     const priceCurrent = box.querySelector('.selected-product-box__price-current');
//     const priceCompare = box.querySelector('.selected-product-box__price-compare');
//     const product = getProductDetails[index];

//     if (!priceCurrent || !product) {
//       return;
//     }

//     if (isBundleComplete && index === getProductDetails.length - 1) {
//       priceCurrent.textContent = 'FREE';
//       priceCurrent.classList.add('selected-product-box__price-current--free');
//       if (priceCompare) {
//         priceCompare.style.display = 'none';
//       }
//     } else {
//       priceCurrent.classList.remove('selected-product-box__price-current--free');
//       priceCurrent.textContent = product.price;
//       if (priceCompare) {
//         priceCompare.style.display = '';
//       }
//     }
//   });
// }

// to show prices as it's
function updateBundlePriceLabels() {
  const selectedCount = getProductDetails.length;
  const rate = getCurrencyRate();
  const tierSalePriceByCount = {
    2: formatPrice(TIER_2_PRICE * rate, extractCurrencyInfo(getProductDetails[0]?.price || '$')),
    3: formatPrice(TIER_3_PRICE * rate, extractCurrencyInfo(getProductDetails[0]?.price || '$'))
  };

  const previewProducts = getProductDetails;

  productBoxes.forEach((box, index) => {
    if (!box.classList.contains('filled')) {
      return;
    }

    const priceCurrent = box.querySelector('.selected-product-box__price-current');
    const priceCompare = box.querySelector('.selected-product-box__price-compare');
    const product = previewProducts[index];

    if (!priceCurrent || !product) {
      return;
    }

    priceCurrent.classList.remove('selected-product-box__price-current--free');

    if (selectedCount === 1) {
      // 1 selected: show only original price (no sale)
      priceCurrent.textContent = product.comparePrice || product.price;
      if (priceCompare) {
        priceCompare.style.display = 'none';
      }
      return;
    }

    if (tierSalePriceByCount[selectedCount]) {
      // 2-3 selected: show tier sale price + original compare
      priceCurrent.textContent = tierSalePriceByCount[selectedCount];
      if (priceCompare) {
        if (product.comparePrice) {
          priceCompare.textContent = product.comparePrice;
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      return;
    }

    // 4+ selected: keep default per-product display
    priceCurrent.textContent = product.price;
    if (priceCompare) {
      if (product.comparePrice) {
        priceCompare.textContent = product.comparePrice;
        priceCompare.style.display = '';
      } else {
        priceCompare.style.display = 'none';
      }
    }
  });
}

async function addProductToBundle(productData) {
  if (isCartSyncing || !productData || !productData.id) {
    return false;
  }

  const wrapper = document.querySelector(
    `[data-quantity-wrapper][data-product-id="${productData.id}"]`
  );
  const atcBtn = getAtcButtonByProductId(productData.id);
  const inventorySource = wrapper || atcBtn;
  if (!inventorySource || !canAddMoreVariant(inventorySource.dataset)) {
    return false;
  }

  isCartSyncing = true;
  updateProductButtonsState();
  showBundleLoading();

  try {
    const cart = await addVariantToCart(productData.id);
    console.log("productData.id::" , productData.id);
    syncFromCart(cart);
    return true;
  } catch (error) {
    console.error('Bundle add to cart failed:', error);
    alert('There was an error adding this item to your cart. Please try again.');
    return false;
  } finally {
    isCartSyncing = false;
    updateProductButtonsState();
    hideBundleLoading();
  }
}

// Function to clear a product box back to empty state
function clearProductBox(box) {
  box.classList.remove('filled');
  box.classList.add('empty');
  box.removeAttribute('data-array-index');
  
  box.innerHTML = EMPTY_PRODUCT_BOX_HTML;
}

// Function to populate product box with product details
function populateProductBox(index, productData) {
  const box = document.querySelector(`[data-product-box="${index}"]`);
  if (!box) return;
  
  // Remove empty state
  box.classList.remove('empty');
  box.classList.add('filled');
  box.setAttribute('data-array-index', productData.arrayIndex);
  
  // Use prices directly from productData (already formatted from Shopify)
  const displayPrice = productData.price;
  const displayComparePrice = productData.comparePrice || '';
  
  // Create product content HTML
  const productHTML = `
    <div class="selected-product-box__content">
      <img src="${productData.image}" alt="${productData.title}" class="selected-product-box__image">
      <span class="selected-product-box__remove" data-remove-index="${productData.arrayIndex}">
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
        <path d="M0.5 5.5L5.5 0.5M0.5 0.5L5.5 5.5" stroke="black" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      </span>
      <span class="selected-product-box__title">${productData.title}</span>
      <div class="selected-product-box__price">
        ${displayComparePrice ? `<span class="selected-product-box__price-compare">${displayComparePrice}</span>` : ''}
        <span class="selected-product-box__price-current">${displayPrice}</span>
      </div>
    </div>
  `;
  
  box.innerHTML = productHTML;
  
  // Add click event to remove button
  const removeBtn = box.querySelector(`[data-remove-index="${productData.arrayIndex}"]`);
  if (removeBtn) {
    removeBtn.addEventListener('click', () => removeProduct(productData.arrayIndex));
  }
}

// Function to rebuild selected product boxes (shows all selected items)
function rebuildProductBoxes() {
  productBoxes.forEach(function (box) {
    clearProductBox(box);
  });

  getProductDetails.forEach(function (product, boxIndex) {
    populateProductBox(boxIndex, product);
  });

  const shouldScrollToEnd = getProductDetails.length > previousSelectedProductCount;
  previousSelectedProductCount = getProductDetails.length;

  updateSelectedProductsSliderState();

  if (shouldScrollToEnd) {
    requestAnimationFrame(function () {
      scrollSelectedProductsToEnd();
    });
  }
}

// Function to remove a product from cart and sync UI
async function removeProduct(arrayIndex) {
  const removedProduct = getProductDetails[arrayIndex];
  if (!removedProduct || isCartSyncing) {
    return;
  }

  isCartSyncing = true;
  updateProductButtonsState();
  showBundleLoading();

  try {
    const cart = await removeOneVariantFromCart(removedProduct.id);
    syncFromCart(cart);
  } catch (error) {
    console.error('Bundle remove from cart failed:', error);
    alert('There was an error updating your cart. Please try again.');
  } finally {
    isCartSyncing = false;
    updateProductButtonsState();
    hideBundleLoading();
  }
}

getBundleAtc.forEach(function (item) {
  item.addEventListener('click', async function () {
    const productData = buildProductDataFromDataset(item.dataset);
    await addProductToBundle(productData);
  });
});

quantityWrappers.forEach(wrapper => {
  const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
  const decreaseBtn = wrapper.querySelector('[data-quantity-decrease]');

  if (!increaseBtn || !decreaseBtn) {
    return;
  }

  increaseBtn.addEventListener('click', async function () {
    const productData = buildProductDataFromDataset(wrapper.dataset);
    await addProductToBundle(productData);
  });

  decreaseBtn.addEventListener('click', async function () {
    const productId = wrapper.dataset.bundleId || wrapper.dataset.productId;
    const removeIndex = getProductDetails.map(function (product) {
      return product.id;
    }).lastIndexOf(productId);
    if (removeIndex === -1) {
      return;
    }
    await removeProduct(removeIndex);
  });
});

// Checkout: bundle items are already in cart from each Add click
if (bundleSubmitButton) {
  bundleSubmitButton.addEventListener('click', function () {
    if (getProductDetails.length < 1) {
      return;
    }
    window.location.href = '/checkout';
  });
}

// Mobile toggle functionality
const bundleToggle = document.querySelector('.custom-bundle__wrapper-left-toggle');
const bundleWrapper = document.querySelector('.custom-bundle__wrapper-left');

if (bundleToggle && bundleWrapper) {
  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Initialize collapsed state on mobile
  if (isMobile()) {
    bundleWrapper.classList.add('collapsed');
  }
  
  bundleToggle.addEventListener('click', () => {
    if (isMobile()) {
      if (getProductDetails.length === 0) {
        bundleWrapper.classList.add('collapsed');
        bundleToggle.classList.remove('rotated');
        return;
      }
      bundleWrapper.classList.toggle('collapsed');
      bundleToggle.classList.toggle('rotated');
    }
  });

  // View Bundle button: open the left panel when collapsed
  const viewBundleBtn = document.querySelector('[data-view-bundle]');
  if (viewBundleBtn) {
    viewBundleBtn.addEventListener('click', () => {
      if (isMobile() && bundleWrapper.classList.contains('collapsed')) {
        bundleWrapper.classList.remove('collapsed');
        bundleToggle.classList.remove('rotated');
      }
    });
  }
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (!isMobile()) {
        bundleWrapper.classList.remove('collapsed');
        bundleToggle.classList.remove('rotated');
      } else {
        updateMobileCollapsedState();
      }
    }, 250);
  });
}

// ————— Bundle product quick-view modal —————
const bundleModal = document.querySelector('[data-bundle-modal]');
const bundleModalGallery = document.querySelector('[data-bundle-modal-gallery]');
const bundleModalThumbnails = document.querySelector('[data-bundle-modal-thumbnails]');
const bundleModalReviews = document.querySelector('[data-bundle-modal-reviews]');
const bundleModalTitle = document.querySelector('[data-bundle-modal-title]');
const bundleModalFooter = document.querySelector('[data-bundle-modal-footer]');
const bundleModalViewProduct = document.querySelector('[data-bundle-modal-view-product]');
const bundleModalAddBtn = document.querySelector('[data-bundle-modal-add]');
const bundleModalQuantity = document.querySelector('[data-bundle-modal-quantity]');
const bundleModalQtyValue = document.querySelector('[data-bundle-modal-qty-value]');
const bundleModalQtyIncrease = document.querySelector('[data-bundle-modal-qty-increase]');
const bundleModalQtyDecrease = document.querySelector('[data-bundle-modal-qty-decrease]');

function getCardByProductId(productId) {
  const el = document.querySelector(
    `.custom-bundle__collection-product [data-bundle-id="${productId}"], .custom-bundle__collection-product [data-product-id="${productId}"]`
  );
  return el ? el.closest('.custom-bundle__collection-product') : null;
}

function getProductDataFromCard(card) {
  const wrapper = card ? card.querySelector('[data-quantity-wrapper]') : null;
  const atcBtn = card ? card.querySelector('[data-bundle-atc]') : null;
  const source = wrapper || atcBtn;
  return source ? buildProductDataFromDataset(source.dataset) : null;
}

function updateBundleModalFooter(productId) {
  if (!bundleModalFooter || !productId) return;
  const qty = getProductQuantity(productId);
  const card = getCardByProductId(productId);
  const wrapper = card ? card.querySelector('[data-quantity-wrapper]') : null;
  const atcBtn = card ? card.querySelector('[data-bundle-atc]') : null;
  const inventorySource = wrapper || atcBtn;
  const canAdd = inventorySource ? canAddMoreVariant(inventorySource.dataset) : false;

  if (bundleModalViewProduct) {
    if (qty > 0) {
      bundleModalViewProduct.classList.add('custom-bundle-hidden');
      bundleModalAddBtn.classList.add('custom-bundle-hidden');
      bundleModalQuantity.classList.remove('custom-bundle-hidden');
    } else {
      bundleModalViewProduct.classList.remove('custom-bundle-hidden');
      bundleModalAddBtn.classList.remove('custom-bundle-hidden');
      bundleModalQuantity.classList.add('custom-bundle-hidden');
      bundleModalAddBtn.disabled = isCartSyncing || !canAdd;
      bundleModalAddBtn.style.opacity = isCartSyncing || !canAdd ? '0.5' : '1';
      bundleModalAddBtn.style.cursor = isCartSyncing || !canAdd ? 'not-allowed' : 'pointer';
    }
  }
  if (bundleModalQtyValue) bundleModalQtyValue.textContent = String(qty > 0 ? qty : 1);
  if (bundleModalQtyIncrease) {
    bundleModalQtyIncrease.disabled = isCartSyncing || !canAdd;
  }
  if (bundleModalQtyDecrease) bundleModalQtyDecrease.disabled = isCartSyncing;
}

function openBundleModal(card) {
  if (!bundleModal || !card) return;
  const productUrl = card.dataset.productUrl || '#';
  const imagesRaw = (card.dataset.productImages || '').trim();
  const images = imagesRaw ? imagesRaw.split('|||') : [];
  const productData = getProductDataFromCard(card);
  if (!productData) return;

  const productId = productData.id;
  bundleModal.setAttribute('data-modal-product-id', productId);
  bundleModal.setAttribute('aria-hidden', 'false');

  const track = bundleModalGallery ? bundleModalGallery.querySelector('.custom-bundle-modal__gallery-track') : null;
  const imageList = images.length ? images : [productData.image];
  if (track) {
    track.innerHTML = imageList
      .map(
        (src) =>
          `<div class="custom-bundle-modal__gallery-slide"><img src="${src}" alt="" loading="lazy" /></div>`
      )
      .join('');
  }
  if (bundleModalThumbnails) {
    bundleModalThumbnails.innerHTML = imageList
      .map(
        (src, i) =>
          `<button type="button" class="custom-bundle-modal__thumb${i === 0 ? ' is-active' : ''}" data-bundle-modal-thumb-index="${i}" aria-label="View image ${i + 1}"><img src="${src}" alt="" loading="lazy" /></button>`
      )
      .join('');
    bundleModalThumbnails.querySelectorAll('.custom-bundle-modal__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-bundle-modal-thumb-index'), 10);
        var slide = track && track.children[index];
        if (slide) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        bundleModalThumbnails.querySelectorAll('.custom-bundle-modal__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });
  }

  if (bundleModalTitle) bundleModalTitle.textContent = productData.title || '';
  if (bundleModalTitle) bundleModalTitle.setAttribute('href', productUrl);
  if (bundleModalViewProduct) bundleModalViewProduct.setAttribute('href', productUrl);

  var shopifyProductId = card.getAttribute('data-shopify-product-id');
  if (shopifyProductId) {
    bundleModal.setAttribute('data-modal-shopify-product-id', shopifyProductId);
    var looxEl = card.querySelector('[data-bundle-loox-product-id="' + shopifyProductId + '"]');
    if (bundleModalReviews && looxEl && looxEl.firstElementChild) {
      while (bundleModalReviews.firstChild) bundleModalReviews.removeChild(bundleModalReviews.firstChild);
      bundleModalReviews.appendChild(looxEl.firstElementChild);
    }
  }

  updateBundleModalFooter(productId);
  document.body.classList.add('custom-bundle-modal-open');
}

function closeBundleModal() {
  if (!bundleModal) return;
  var shopifyProductId = bundleModal.getAttribute('data-modal-shopify-product-id');
  if (shopifyProductId && bundleModalReviews && bundleModalReviews.firstElementChild) {
    var card = document.querySelector('.custom-bundle__collection-product[data-shopify-product-id="' + shopifyProductId + '"]');
    var looxEl = card ? card.querySelector('[data-bundle-loox-product-id="' + shopifyProductId + '"]') : null;
    if (looxEl) {
      looxEl.appendChild(bundleModalReviews.firstElementChild);
    }
  }
  bundleModal.setAttribute('aria-hidden', 'true');
  bundleModal.removeAttribute('data-modal-product-id');
  bundleModal.removeAttribute('data-modal-shopify-product-id');
  document.body.classList.remove('custom-bundle-modal-open');
}

document.querySelectorAll('[data-open-bundle-modal]').forEach(function (trigger) {
  trigger.addEventListener('click', function () {
    const card = this.closest('.custom-bundle__collection-product');
    openBundleModal(card);
  });
});

[bundleModalAddBtn].filter(Boolean).forEach(function (btn) {
  btn.addEventListener('click', async function () {
    const productId = bundleModal.getAttribute('data-modal-product-id');
    const card = getCardByProductId(productId);
    const productData = getProductDataFromCard(card);
    if (!productData) return;
    await addProductToBundle(productData);
    updateBundleModalFooter(productId);
  });
});

[bundleModalQtyIncrease].filter(Boolean).forEach(function (btn) {
  btn.addEventListener('click', async function () {
    const productId = bundleModal.getAttribute('data-modal-product-id');
    const card = getCardByProductId(productId);
    const productData = getProductDataFromCard(card);
    if (!productData) return;
    await addProductToBundle(productData);
    updateBundleModalFooter(productId);
  });
});

[bundleModalQtyDecrease].filter(Boolean).forEach(function (btn) {
  btn.addEventListener('click', async function () {
    const productId = bundleModal.getAttribute('data-modal-product-id');
    const removeIndex = getProductDetails.map(function (p) {
      return p.id;
    }).lastIndexOf(productId);
    if (removeIndex === -1) return;
    await removeProduct(removeIndex);
    updateBundleModalFooter(productId);
  });
});

document.querySelectorAll('[data-bundle-modal-close]').forEach(function (el) {
  el.addEventListener('click', closeBundleModal);
});

if (bundleModal) {
  bundleModal.addEventListener('click', function (e) {
    if (e.target === bundleModal || e.target.classList.contains('custom-bundle-modal__backdrop'))
      closeBundleModal();
  });
}

if (bundleModalGallery && bundleModalThumbnails) {
  bundleModalGallery.addEventListener('scroll', function () {
    if (bundleModal.getAttribute('aria-hidden') !== 'false') return;
    var track = bundleModalGallery.querySelector('.custom-bundle-modal__gallery-track');
    if (!track || !track.children.length) return;
    var scrollLeft = bundleModalGallery.scrollLeft;
    var slideWidth = track.children[0].offsetWidth;
    var index = slideWidth ? Math.round(scrollLeft / slideWidth) : 0;
    index = Math.max(0, Math.min(index, track.children.length - 1));
    bundleModalThumbnails.querySelectorAll('.custom-bundle-modal__thumb').forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
  }, { passive: true });
}

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && bundleModal && bundleModal.getAttribute('aria-hidden') === 'false')
    closeBundleModal();
});

function initializeButtonStates() {
  updateProductButtonsState();
}

if (typeof theme !== 'undefined' && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (!event || event.source === 'custom-bundle') {
      return;
    }
    if (event.cart && event.cart.items) {
      syncFromCart(event.cart);
      return;
    }
    fetchCart().then(syncFromCart).catch(function () {});
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initSelectedProductsSlider();
    initializeButtonStates();
    initBundleFromCart();
  });
} else {
  initSelectedProductsSlider();
  initializeButtonStates();
  initBundleFromCart();
}